import React from "react";
import curvetext from '../images/new/footer/curvetext.svg'
import footerSun from '../images/new/footer/footer-sun.png'
import linkedin from '../images/new/footer/linkedin.png'
import facebook from '../images/new/footer/facebook.png'
import footerDiscord from '../images/new/footer/discord.png'
import instagram from '../images/new/footer/instagram.png'
import footerCurve2 from '../images/new/footer/footer-curve2.svg'
import footerLogo from '../images/new/footer/footer-logo.png'
import footerTwitter from '../images/new/footer/twitter.png'
import footerFemale from '../images/new/footer/footer-female.png'
function Footer() {
  return (
    <footer id="footer">
      <div className="wrapper">
        <h2>
          <img src={curvetext} alt="curvetext" />
        </h2>
        <div className="social">
          <div className="f-sun rotate linear infinite">
            <img src={footerSun} alt="footer sun" />
          </div>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/the-heal-app/" className="linkedin">
              <img src={linkedin} alt="" />
            </a>
            <a href="https://discord.com/invite/tsvjugjFZx" className="discord">
              <img src={footerDiscord} alt="" />
            </a>
            {/* <a href="/" className="discord">
              <img src={footerDiscord} alt="" />
            </a> */}
            <a href="https://www.instagram.com/healingnfts/" className="instagram">
              <img src={instagram} alt="" />
            </a>
            <a href="https://twitter.com/HealingNFTs" className="twitter">
              <img src={footerTwitter} alt="" />
            </a>
          </div>
          <img src={footerFemale} className="footer-female" alt="" />
        </div>
        <div className="footer-logo">
          <img className="logo" src={footerLogo} alt="" />
          <img src={footerCurve2} alt="" />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
